import React from 'react'
import { useParams } from 'react-router-dom'
import Page from '../../component/page'
import RegionChart from './RegionChart'

function Region() {
  const { region } = useParams()
  return (
    <Page>
      <RegionChart region={region} />
    </Page>
  )
}

export default Region
